<template lang="slm">
  div
    .section.items
      .container
        h2 Аудиопроповеди
        .row.pt-4.pb-4
          .col-12.col-sm-6.col-lg-4.col-xl-3 v-for='audio in audioPreachings'
            audio-preach :image-id='audio.imageId' :title='audio.title' :speaker='audio.speaker' :date='audio.date' :file-id='audio.fileId' :duration='audio.duration'
</template>

<style lang="stylus" scoped>
.section
  &.items
    background-color white
    .container
      text-align center
      .items
        text-align left
        display block
        .item
          display inline-block
          text-align center
          width calc(25% - 50px)
          margin 25px
</style>

<script>
import gql from 'graphql-tag';
import AudioPreach from '@/components/AudioPreach';

export default {
  name: 'AudioPreachingsPage',
  components: { AudioPreach },
  data() {
    return {
      audioPreachings: [],
    };
  },
  apollo: {
    audioPreachings: {
      query: gql`{ audioPreachings { imageId title speaker date fileId duration } }`,
    },
  },
};
</script>
